import { createContext } from 'react';

export const DialogFunctionContext = createContext({

  showDialog : false, //setting default value 
  closeDialog: (show: boolean) => {}
});

